export default async function setCache({ apolloClient, query, variables }){
  /** Preload content **/
  let result = await apolloClient.query({ query, variables, fetchPolicy: 'cache-first' });
  /** set cache content **/
  await apolloClient.writeQuery({ query, variables, data: result?.data });
}